import { render } from "./StatusSteps.vue?vue&type=template&id=2d0031f6&scoped=true"
import script from "./StatusSteps.vue?vue&type=script&lang=js"
export * from "./StatusSteps.vue?vue&type=script&lang=js"

import "./StatusSteps.vue?vue&type=style&index=0&id=2d0031f6&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0031f6"]])

export default __exports__